"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyDatabaseQueryResults = exports.LegacyDatabaseQueryResultsColumn = void 0;
exports.queryResultsFromLegacy = queryResultsFromLegacy;
exports.queryResultsToLegacy = queryResultsToLegacy;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const legacyDatabase_1 = require("./legacyDatabase");
exports.LegacyDatabaseQueryResultsColumn = zod_1.z.object({
    name: zod_1.z.string(),
    ref: legacyDatabase_1.LegacyColumnRef.optional(),
}).strict();
exports.LegacyDatabaseQueryResults = zod_1.z.object({
    query: zod_1.z.string(),
    columns: exports.LegacyDatabaseQueryResultsColumn.array(),
    rows: legacyDatabase_1.LegacyJsValue.array(),
}).strict().describe('LegacyDatabaseQueryResults');
function queryResultsFromLegacy(r) {
    return {
        query: r.query,
        attributes: r.columns.map(({ name, ref }) => (0, utils_1.removeUndefined)({
            name,
            ref: ref ? (0, legacyDatabase_1.columnRefFromLegacy)(ref) : undefined
        })),
        rows: r.rows
    };
}
function queryResultsToLegacy(r) {
    return {
        query: r.query,
        columns: r.attributes.map(({ name, ref }) => (0, utils_1.removeUndefined)({
            name,
            ref: ref ? (0, legacyDatabase_1.columnRefToLegacy)(ref) : undefined
        })),
        rows: r.rows.map(jsValueToLegacy)
    };
}
function jsValueToLegacy(v) {
    return v;
}
//# sourceMappingURL=legacyQuery.js.map